import React, {useEffect, useState} from "react";
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import {Import, Warning} from "assets/icons";
import ModalFooter from "components/modal/components/footer";
import Button from "components/button";
import axios from "axios";
import ApiDatabase from "server";
import {toast} from "react-toastify";
import Divider from "components/divider/divider";
import useModal from "components/modal/useModal";
import UseContext from "hooks/useContext";
import LoadingButton from "components/button/loading.js";
import { rejectFileIfTooLarge } from "helper/fileSizeLimit";

const ModalOtherDocument = () => {
    const {refreshLoadWorker} = UseContext();
    const {toggle} = useModal();
    const [singleFile, setSingleFile] = useState("");
    const [titleFile, setTitleFile] = useState("");
    const [selectedType, setSelectedType] = useState(null);
    const [documentTypes, setDocumentTypes] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        ApiDatabase.getAllOtherDocumentTypes(
            (data) => setDocumentTypes(data),
            (err) => console.log(err)
        );
    }, []);

    const handlerSingleFile = (e) => {
        if (rejectFileIfTooLarge(e)) return;
        setSingleFile(e.target.files[0]);
        setTitleFile(e.target.files[0].name);
    };

    const handleTypeChange = (e) => {
        const type = documentTypes.find((t) => t._id === e.target.value);
        setSelectedType(type || null);
    };

    const handleUpload = async (e) => {
        e.preventDefault();
        if (!singleFile) {
            toast.error("Veuillez importer un fichier");
            return;
        }
        if (!selectedType) {
            toast.error("Veuillez sélectionner un type de document");
            return;
        }

        try {
            setLoading(true);
            const formData = new FormData();
            formData.append("otherDocument", singleFile);
            formData.append("otherDocumentName", selectedType.name);
            formData.append("otherDocumentIsUnique", String(selectedType.isUnique));

            await axios.post(
                `${process.env.REACT_APP_API_URL}upload/files`,
                formData
            );
            toast.success("Le document a été ajouté");
            refreshLoadWorker();
            toggle();
        } catch (err) {
            toast.error("Une erreur est survenue");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Modalheader hide={toggle} hideShow={true}>
                Ajouter un document
            </Modalheader>
            <ModalBody>
                <div className="flex flex-col gap-4">
                    <p className="ft-sm text-gray-500">
                        Critères de validation du document :
                    </p>
                    <div className="flex flex-col gap-2">
                        <span className="flex gap-2 items-center">
                            <Warning wh={17} color={"#EF4444"} /> Le document doit être
                            de bonne qualité
                        </span>
                        <Divider w={100} />
                        <span className="flex gap-2 items-center">
                            <Warning wh={17} color={"#EF4444"} />
                            Les informations doivent être lisibles
                        </span>
                    </div>
                    <select
                        onChange={handleTypeChange}
                        className="w-full h-10 pl-3 pr-8 ft-b placeholder-gray-600 border rounded-lg"
                    >
                        <option value="">Sélectionner un type</option>
                        {[...documentTypes]
                            .sort((a, b) =>
                                (a.name ?? "").localeCompare(b.name ?? "", "fr", {
                                    sensitivity: "base",
                                })
                            )
                            .map((item) => (
                                <option key={item._id} value={item._id}>
                                    {item.name}
                                </option>
                            ))}
                    </select>
                    <form id="uploadForm" className="flex flex-col gap-1">
                        <label className="w-full flex flex-row border border-gray-300 rounded-lg h-11 shadow-sm">
                            <div className="ft-sm text-gray-700 w-1/4 p-4 flex items-center justify-center gap-2 border-r border-gray-300">
                                <Import color={"#374151"} wh={14} />
                                Importer
                            </div>
                            <div className="ft-sm truncate overflow-hidden text-gray-400 flex items-center ml-3">
                                {titleFile ? titleFile : "Aucun fichier"}
                            </div>
                            <input
                                type="file"
                                id="file"
                                accept="application/pdf,image/jpeg,image/jpg,image/png,image/gif,image/bmp,image/tiff"
                                className="hidden"
                                onChange={(e) => handlerSingleFile(e)}
                            />
                        </label>
                        <span className="ft-xs text-gray-400">
                            Images, PDF (10Mo max)
                        </span>
                    </form>
                </div>
            </ModalBody>
            <ModalFooter>
                {loading ? (
                    <LoadingButton size={"LG"}/>
                ) : (
                    <>
                        <Button size={"LG"} color={"SECONDARY"} onClick={toggle}>
                            Annuler
                        </Button>
                        <Button size={"LG"} onClick={handleUpload}>
                            Confirmer
                        </Button>
                    </>
                )}
            </ModalFooter>
        </>
    );
};

export default ModalOtherDocument;
